module.exports = __webpack_public_path__ + "static/media/soul-learning-path-navigation-inactive.edf3b9d5.svg";